{
  "app": {
    "shellTitle": "Dink Product Admin · Console da Plataforma",
    "loading": "Carregando"
  },
  "common": {
    "retry": "Tentar novamente",
    "close": "Fechar",
    "menu": "Menu",
    "loading": "Carregando",
    "language": "Idioma",
    "comingSoon": "Em breve",
    "noProgress": "Sem progresso"
  },
  "lang": { "en": "EN", "es": "ES", "fr": "FR", "pt": "PT" },
  "language_switcher": {
    "label": "Idioma",
    "options": {
      "en": "English",
      "es": "Español",
      "fr": "Français",
      "pt": "Português"
    }
  },
  "nav": {
    "signOut": "Sair",
    "signIn": "Entrar",
    "group": { "operations": "Operações", "configuration": "Configuração" },
    "dashboard": "Painel",
    "queue": "Fila",
    "notifications": "Notificações",
    "logs": "Registros",
    "tenants": "Inquilinos",
    "engine": "Motor",
    "globalConfig": "Configuração global"
  },
  "shell": {
    "scope": "Plataforma — todos os inquilinos",
    "notificationsAriaLabel": "Notificações",
    "accountMenu": "Conta"
  },
  "page": {
    "dashboard": { "title": "Painel" },
    "queue": { "title": "Fila" },
    "notifications": { "title": "Notificações" },
    "logs": { "title": "Registros" },
    "tenants": { "title": "Inquilinos" },
    "engine": { "title": "Motor" },
    "globalConfig": { "title": "Configuração global" }
  },
  "bootstrap": {
    "error": "Não foi possível carregar a configuração do aplicativo.",
    "errorNotRegistered": "Este host não está registrado. Entre em contato com o administrador.",
    "retry": "Tentar novamente"
  },
  "auth": {
    "redirecting": "Redirecionando para login…",
    "returning": "Concluindo login…",
    "noAccessTitle": "Você não tem acesso a este console",
    "noAccessBody": "Sua conta está conectada, mas não recebeu acesso a este console de administração do produto. Entre em contato com o administrador se acreditar que isso é um erro.",
    "productAdminRequired": "Acesso de administrador do produto necessário",
    "productAdminRequiredBody": "Você está conectado, mas sua conta não recebeu acesso a este console de administração do produto.",
    "signedOutTitle": "Você saiu",
    "signedOutBody": "Sua sessão de administrador do produto foi encerrada.",
    "signInAgain": "Entrar novamente"
  },
  "errors": {
    "generic": "Algo deu errado. Por favor, tente novamente.",
    "network": "Erro de rede. Verifique sua conexão e tente novamente.",
    "notFoundTitle": "Não encontrado",
    "notFoundBody": "Não encontramos o que você procurava."
  },
  "help": {
    "ariaLabel": "Ajuda para {{label}}"
  }
}
